import React from "react";

const PurchaseRequestSkeleton: React.FC = () => (
  <div className="flex flex-col min-h-[500px] space-y-4">
    <div className="flex-1 min-h-0">
      <div className="space-y-3 h-full overflow-y-auto">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0"
          >
            <div className="flex-1">
              <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-3/4"></div>
              <div className="h-3 bg-gray-100 rounded animate-pulse w-1/2"></div>
            </div>
            <div className="text-right">
              <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default PurchaseRequestSkeleton;
